import useSWR from "swr";
import { http } from "~/services/http";

export const useFetchActiveAndUpcomingEvent = (onSuccess, onError) => {
  const { data, error, isLoading } = useSWR("/api/user/events/active-and-upcoming", http.get, {
    ...(!!onSuccess && { onSuccess: onSuccess }),
    ...(!!onError && { onError: onError }),
  });

  // If data status is 204 (http "No Content"), there is no next event
  const noContent = data?.status === 204;
  const activeEvents = noContent ? [] : (data?.activeEvents ?? []);
  const totalActiveEvent = noContent ? 0 : (data?.totalActiveEvent ?? 0);
  const upcomingEvent = noContent ? null : (data?.upcomingEvent ?? null);
  const studySiteLocalTime = noContent ? null : (data?.studySiteLocalTime ?? null);

  return { activeEvents, totalActiveEvent, upcomingEvent, studySiteLocalTime, error, isLoading };
};
